import React from 'react';

export function Card({ children, className = '', hover = false, padding = true }) {
  return (
    <div
      className={`bg-prodia-surface border border-prodia-border rounded-xl shadow-prodia ${
        hover ? 'transition-shadow hover:shadow-prodia-md' : ''
      } ${padding ? 'p-4' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, description, action, className = '' }) {
  return (
    <div className={`flex items-start justify-between gap-4 mb-4 ${className}`}>
      <div>
        {title && <h3 className="text-base font-semibold text-prodia-text-primary">{title}</h3>}
        {description && <p className="text-sm text-prodia-text-secondary mt-0.5">{description}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}

export function CardBody({ children, className = '' }) {
  return <div className={className}>{children}</div>;
}

export default Card;
